import getDecodedJWTToken from './getDecodedJWTToken';
import { resolveImpersonationMode } from './resolveImpersonationMode';

let lastLoggedMismatchKey = '';

/**
 * Verifica se siamo in modalità impersonation.
 * @returns true se siamo in modalità impersonation, altrimenti false
 */
export const getIsImpersonation = (): boolean => {
  const decodedJwt = getDecodedJWTToken();
  const resolution = resolveImpersonationMode({
    currentOrigin: window.location.origin,
    impersonationRedirectUri: import.meta.env
      .VITE_NX_PUBLIC_REDIRECT_URI_IMPERSONATE,
    tokenType: decodedJwt?.type,
  });

  if (!resolution.hasMismatch) {
    lastLoggedMismatchKey = '';
    return resolution.isImpersonation;
  }

  const mismatchKey = `${window.location.origin}:${decodedJwt?.type || 'missing'}`;
  if (lastLoggedMismatchKey !== mismatchKey) {
    lastLoggedMismatchKey = mismatchKey;
    console.warn(
      '[getIsImpersonation] Dominio e token non sono allineati, mantengo la modalità impersonation se uno dei due la richiede.',
      {
        currentOrigin: window.location.origin,
        tokenType: decodedJwt?.type || 'missing',
      },
    );
  }

  return resolution.isImpersonation;
};
